import { AuthActions, AUTH_ACTION_TYPE } from './auth-type';
import { RootState } from '../redux/root-reducer';
import { COGNITO_CHALLENGE } from './auth-constant';

export enum AUTH_STATE_KEY {
  ID_TOKEN = 'idToken',
  STATUS = 'STATUS',
  ROLE = 'ROLE',
  EXPIRE_TIME = 'EXPIRE_TIME',
  COGNITO_USER = 'COGNITO_USER',
  SESSION = 'SESSION',
  EMAIL = 'EMAIL',
}

export type AuthState = {
  [AUTH_STATE_KEY.ID_TOKEN]?: string,
  [AUTH_STATE_KEY.ROLE]?: string,
  [AUTH_STATE_KEY.STATUS]?: COGNITO_CHALLENGE,
  [AUTH_STATE_KEY.EXPIRE_TIME]?: Date,
  [AUTH_STATE_KEY.SESSION]?: string,
  [AUTH_STATE_KEY.COGNITO_USER]?: any,
  [AUTH_STATE_KEY.EMAIL]?: string,
};

const initialState: AuthState = {
  [AUTH_STATE_KEY.ID_TOKEN]: undefined,
  [AUTH_STATE_KEY.EXPIRE_TIME]: undefined,
  [AUTH_STATE_KEY.STATUS]: undefined,
  [AUTH_STATE_KEY.SESSION]: undefined,
  [AUTH_STATE_KEY.COGNITO_USER]: undefined,
  [AUTH_STATE_KEY.EMAIL]: undefined,
};

export const authReducers = (state = initialState, action: AuthActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case AUTH_ACTION_TYPE.SET_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const authStateSelector = (key: AUTH_STATE_KEY) => (state: RootState) => state.auth[key];
// GET_EXPIRE_TIME = 'GET_EXPIRE_TIME',
